export const routes = {
  ROOT: '/',
  LOGIN: '/login',
  MULTI_FACTOR: '/2fa',
  MULTI_FACTOR_SETUP: '/activate-2fa',
  REGISTRATION: '/registration',
  REGISTRATION_COMPLETED: '/registration-completed',
  RESET_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD_CHECK_EMAIL: '/reset-password-check-email',
  SETUP_PASSWORD: '/auth/setup-password',
  EDIT_PROFILE: '/edit-profile',
  ACCOUNT: '/account',
  FORGOT_CREDENTIALS: '/forgot',
  LIBRARY: '/library',
  ADVANCED_SEARCH: '/advanced-search',
  DISTRIBUTORS: '/distributors',
  FILM: '/film',
  FILM_DETAILS: '/film-details',
  // ADD_FILM: '/add-film',
  PRIVACY_POLICY: '/privacy',
  TERMS_CONDITIONS: '/terms',
  CONTACT_US: '/contact',
  ABOUT: '/about',
  SEARCH_RESULTS: '/search-results',
  DISTRIBUTOR_FILMS: '/distributor-films',
  DATA_AUDIT: '/data-audit',
  FILMS_BY_METRIC: '/films-by-metric',
  PREDICTIONS: '/predictions',
  PREDICTIONS_ENGINE: '/predictions-engine',
  PERSON: '/person',
  ANALYTICS_REPORT: '/analytics-report',
  REPORT_PRINT: '/report-print',
  NEW_PASSWORD_EMAIL_REDIRECT: '/auth/forgot-password/new',
} as const;
